import React from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router';
import { setVisualized } from 'stores/notifications/notificationActions';
import NotificationContainer from './NotificationContainer';

const NotificationCommonItem = ({ item }) => {
  const { notification } = item;
  const history = useHistory();
  const dispatch = useDispatch();

  const handlePress = () => {
    const { pathname } = window.location;

    const parameters = JSON.parse(notification.parameters ?? '{}');
    dispatch(setVisualized(item.id));

    if (
      pathname.startsWith('/app/recipient-care/profiles/') &&
      pathname.endsWith('/history')
    ) {
      history.replace(
        `/app/recipient-care/profiles/${parameters.patientId}/history`
      );
      window.location.reload();
      return;
    }

    history.push(`/app/recipient-care/profiles/${parameters.patientId}/history`);
  };

  return (
    <NotificationContainer onClick={handlePress} item={item}>
      <div className="gx-fs-lg gx-font-weight-semi-bold gx-mb-1">
        {notification.title}
      </div>
      <div className="gx-fs-md">{notification.description}</div>
    </NotificationContainer>
  );
};

export default NotificationCommonItem;
